import React, { useEffect, useState } from "react";
import simbolSesion from '../../../../../assets/media/icons/simbolSesion.svg'
import "./sessionState.scss";
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import { Button, Menu, MenuItem } from "@mui/joy";
import { appConfigPerfiles, appSecurityConfiguration } from "../../../../../config/Config";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import WelcomeName from "./welcomeName";
import Typography from "@mui/material/Typography";
import RequestManager from "../../../../services/origination/wapirequest.service"
import { MnConsultarPerfilResponse } from "../../../../models/RequestManager/consultar-perfil";

function SesionState() {
	const { instance } = useMsal();

	const [perfiles, setPerfiles] = useState<MnConsultarPerfilResponse[]>([]);

	const [anchorPerfil, setAnchorPerfil] = React.useState<null | HTMLElement>(null);
	const openPerfil = Boolean(anchorPerfil);
	const [anchorSesion, setAnchorSesion] = React.useState<null | HTMLElement>(null);
	const openSesion = Boolean(anchorSesion);

	const handleClickPerfil = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorPerfil(event.currentTarget);
	};
	const handleClosePerfil = () => {
		setAnchorPerfil(null);
	};

	const handleClickSesion = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorSesion(event.currentTarget);
	};
	const handleCloseSesion = () => {
		setAnchorSesion(null);
	};

	const handleLogout = () => {
		setAnchorSesion(null);
		instance.logoutPopup();
		localStorage.removeItem('UserMn');
		localStorage.removeItem('UserProfileMn');
	};

	const handleChangeProfile = async (idUser: number, idPerfil: number) => {
		setAnchorPerfil(null);
		const profileData = {
			IDENT_USUARIO: idUser,
			IDENT_PERFIL: idPerfil
		}
		await RequestManager.GetMnCambiarPerfil(profileData)
		window.location.reload();
	}

	var user = appSecurityConfiguration.SessionUserId;
	var perfil = appSecurityConfiguration.SessionPerfil;

	useEffect(() => {
		if (user !== 1) {
			const fetchData = async () => {
				const userID = {
					IDENT_USUARIO: user
				}
				const response = await RequestManager.GetMnConsultarPerfil(userID);
				
				setPerfiles(response.data.content);
			};
			fetchData();
		}
	}, [perfil]);

	return (
		<div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
			{
				perfil === appConfigPerfiles.CodigoJefeBPO || perfil === appConfigPerfiles.CodigoJefeCredito && (
					<>
						<Button
							id="perfil-button"
							aria-controls={openPerfil ? 'perfil-menu' : undefined}
							aria-haspopup="true"
							aria-expanded={openPerfil ? 'true' : undefined}
							variant="outlined"
							color="neutral"
							onClick={handleClickPerfil}
							endDecorator={<ArrowDropDown />}
						>
							<Typography>Perfil</Typography>
						</Button>
						<Menu
							id="perfil-menu"
							anchorEl={anchorPerfil}
							open={openPerfil}
							onClose={handleClosePerfil}
							aria-labelledby="perfil-button"
						>
							{
								perfiles?.map((perfil) => 
									(
										<MenuItem key={perfil.idenT_PERFIL} onClick={() => handleChangeProfile(user, perfil.idenT_PERFIL)}>
											{perfil.desC_PERFIL}
										</MenuItem>
									))
							}
						</Menu>
					</>
				)
			}
			<div className="headSesionStateSimbol" >
				<img src={simbolSesion} alt="burger" />
			</div>
			<Button
				id="usuario-button"
				aria-controls={openSesion ? 'usuario-menu' : undefined}
				aria-haspopup="true"
				aria-expanded={openSesion ? 'true' : undefined}
				variant="outlined"
				color="neutral"
				onClick={handleClickSesion}
				endDecorator={<ArrowDropDown />}
			>
				<WelcomeName />
			</Button>
			<Menu
				id="usuario-menu"
				anchorEl={anchorSesion}
				open={openSesion}
				onClose={handleCloseSesion}
				aria-labelledby="usuario-button"
			>
				<MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
			</Menu>
		</div>
	);
};

export default SesionState;

